import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useEmployeeQuery } from '../../queries/employee_gen'
import { useEmployeeEnrollmentInfoQuery } from '../../queries/employeeEnrollmentInfo_gen'
import {
  UpdateEmploymentStartDateMutation,
  UpdateEmploymentStartDateMutationVariables,
  useUpdateEmploymentStartDateMutation,
} from './updateEmploymentStartDate_gen'
export type { UpdateEmploymentStartDateMutation, UpdateEmploymentStartDateMutationVariables }

export const useUpdateEmploymentStartDate = (
  mutationOptions?: UseGqlMutationCallbacks<
    UpdateEmploymentStartDateMutation,
    UpdateEmploymentStartDateMutationVariables
  >
) =>
  useUpdateEmploymentStartDateMutation(
    useMutationOptionsWithInvalidation(mutationOptions, [
      useEmployeeEnrollmentInfoQuery.getKey(),
      useEmployeeQuery.getKey(),
    ])
  )
